import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import DetailsContainer from '../../Components/DetailsContainer/DetailsContainer';
import RelatedPost from '../../Components/RelatedPost/RelatedPost';
import { getDetails } from '../../features/details/detailsSlice';

const Details = () => {
    const { id } = useParams()
    const { loading, isError, errorMessage, details } = useSelector(state => state.details)
    const dispatch = useDispatch()


    useEffect(() => {
        dispatch(getDetails(id))
    }, [dispatch, id])


    let content = <></>
    if (loading) {
        content = <div className='text-center'>
            Loading...
        </div>
    }
    else if (!loading && isError) {
        content = <div className='text-center'>
            Error something went wrong. data not found!
        </div>
    }
    else if (!loading && !isError && !details.id) {
        content = <div className='text-center'>
            Error Data not found!
        </div>
    }
    else if (!loading && details.id) {
        content = <section className="post-page-container">
            {/* <!-- detailed post  --> */}
            <DetailsContainer></DetailsContainer>
            {/* <!-- detailed post ends --> */}
            {/* <!-- related posts --> */}
            <RelatedPost></RelatedPost>
            {/* <!-- related posts ends --> */}
        </section>

    }
    return (
        <>
            {/* <!-- Go Home / Go Back --> */}
            <div className="container mt-8">
                <Link to="/" className="inline-block text-gray-600 home-btn" id="lws-goHome"><i
                    className="mr-2 fa-solid fa-house"></i>Go Home</Link>
            </div>
            {content}
        </>
    );
};

export default Details;